export const MY_SQUAD = '/my_squad/';
